import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-no-resources',
  templateUrl: './no-resources.component.html',
  styleUrls: ['./no-resources.component.scss']
})
export class NoResourcesComponent {
  @Input() resource = 'resources';
  @Input() message: string;
  @Input() showBorder = true;
  @Input() center = false;

  @Input() triggerButtonText: string;
  @Output() trigger: EventEmitter<void> = new EventEmitter();

  constructor(public elRef: ElementRef) {
  }
}
